/**
 * Query-param-preserving redirects for legacy billing routes.
 * Each redirect forwards the full search string so ?status=overdue etc. still works.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useInsuranceEnabled } from '../../hooks/useInsuranceEnabled';

export function RedirectWithSearch({ to }: { to: string }) {
  const location = useLocation();
  return <Navigate to={{ pathname: to, search: location.search, hash: location.hash }} replace />;
}

export function RedirectPayments() { return <RedirectWithSearch to="/billing/payments" />; }
export function RedirectInvoices() { return <RedirectWithSearch to="/billing/invoices" />; }
export function RedirectSuperbills() { return <RedirectWithSearch to="/billing/superbills" />; }
export function RedirectAdminBilling() { return <RedirectWithSearch to="/billing" />; }

export function RedirectInsurance() {
  const insuranceEnabled = useInsuranceEnabled();
  return insuranceEnabled ? <RedirectWithSearch to="/billing/insurance" /> : <RedirectWithSearch to="/billing" />;
}

export function RedirectPayerPayments() {
  const insuranceEnabled = useInsuranceEnabled();
  return insuranceEnabled ? <RedirectWithSearch to="/billing/payer-payments" /> : <RedirectWithSearch to="/billing" />;
}

export function RedirectClaimDetail() {
  const { claimId } = useParams<{ claimId: string }>();
  const location = useLocation();
  const insuranceEnabled = useInsuranceEnabled();
  const to = insuranceEnabled
    ? `/billing/insurance/claims/${claimId}`
    : '/billing';
  return <Navigate to={{ pathname: to, search: location.search, hash: location.hash }} replace />;
}

export function RedirectBillingEraDetail() {
  const { batchId } = useParams<{ batchId: string }>();
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: `/billing/insurance/era/${batchId}`,
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
}
